export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind} from 'kpc';
import type {SenderAttachment, MessageSendPayload} from 'kpc';

interface Props {
    value?: string
    attachments?: SenderAttachment[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {value: '', attachments: []};
    }

    @bind
    onMessageSend(payload: MessageSendPayload) {
        console.log(
            'send folder files',
            payload.attachments.map(item => ({
                name: item.name,
                relativePath: item.relativePath,
            }))
        );
    }
}